import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'
import { useTheme } from 'embed/hooks'

const Image = require('assets/components/co-applicant.svg')
const styles = require('./styles.scss')

export const CoApplicantOfferBadge: React.FC = () => {
  const { fontFamilyPrimary } = useTheme()
  return (
    <div className={classnames(styles.badgeContainer)}>
      <span
        className={classnames(
          styles.badgeIcon,
          css`
            font-family: ${fontFamilyPrimary};
          `,
        )}
      >
        <Image />
      </span>
      <span>Co-Applicant Added</span>
    </div>
  )
}
